import { render, staticRenderFns } from "./ProductShortDescription.vue?vue&type=template&id=6c22c6dc&scoped=true"
import script from "./ProductShortDescription.vue?vue&type=script&lang=js"
export * from "./ProductShortDescription.vue?vue&type=script&lang=js"
import style0 from "./ProductShortDescription.vue?vue&type=style&index=0&id=6c22c6dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c22c6dc",
  null
  
)

export default component.exports